import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from "@material-ui/core";
import findByString from "../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";

const useStyles = makeStyles(() => ({
    wrapper: {
        display: 'flex',
        marginTop: 8,
        width: 328
    },
    label: {
        width: 102,
        paddingBottom: 6
    },
    list: {
        margin: 0,
        width: 225,
        padding: 0,
        textAlign: 'center'
    },
    listItem: {
        float: 'left',
        listStyle: 'none',
        width: '25%',
        position: 'relative',
        fontSize: '0.7rem',
        '&:hover': {
            '& $inputLabel': {
                color: "#575757",
            }
        }
    },
    inputLabel: {
        color: "#7f7f7f",
        position: "absolute",
        left: "8%",
        top: -8,
        height: 9,
        background: 'white'
    },
    input: {
        outline: 'none',
        width: '100%',
        border: '1px solid #c9c9c9',
        height: 27,
        textAlign: 'center',
    }
}));

const MultiValueField = ({label, placeholders, path, setValue, values, disabled}) => {
    const classes = useStyles();
    const fieldValue = findByString(values, path) || "";
    const matches = fieldValue.match(/\w+/g) || [];

    function onChange({target: {value}}, index) {
        let arrValue = fieldValue.split(" ");
        for (let i = 0; i < 4; i++) {
            if (!arrValue[i]) {
                arrValue[i] = '0px'
            }
        }
        arrValue[index] = value ? `${value}px` : 0;
        setValue(arrValue.join(" "), path);
    }

    return (
        <div className={classes.wrapper}>
            <div className={classes.label}>{label}</div>
            <ul className={classes.list}>
                {placeholders.map((item, index) => {
                    const isFirst = index === 0;
                    const isLast = index + 1 === placeholders.length;
                    const currentValue = matches[index] ? (matches[index].match(/\d+/g) || [])[0] : "";
                    return (
                        <li className={classes.listItem} key={index}>
                            <span className={classes.inputLabel}>{item}</span>
                            <input
                                type={'number'}
                                disabled={disabled}
                                onChange={e => onChange(e, index)}
                                value={currentValue === "0" ? "" : currentValue || ""}
                                className={classes.input}
                                style={{
                                    borderRadius: isFirst ? '4px 0 0 4px' : isLast ? '0 4px 4px 0' : 0,
                                    borderRight: index + 1 !== placeholders.length ? 'none' : '1px solid #c9c9c9',
                                }}
                            />

                        </li>
                    )
                })}
            </ul>
        </div>
    )
};

MultiValueField.propTypes = {
    label: PropTypes.string,
    placeholders: PropTypes.array,
    path: PropTypes.string,
    setValue: PropTypes.func,
    values: PropTypes.object
};

export default MultiValueField;